"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionNotifier = void 0;
const eventEmitter_1 = require("./eventEmitter");
const constants_1 = require("./constants");
const ethRevertReason_1 = __importDefault(require("./ethRevertReason"));
class TransactionNotifier {
    _provider;
    constructor(provider) {
        this._provider = provider;
    }
    hash(transactionHash) {
        const emitter = (0, eventEmitter_1.createEmitter)();
        setTimeout(() => this.watchTransaction(transactionHash, emitter), 5);
        return emitter;
    }
    setProvider(provider) {
        this._provider = provider;
    }
    watchTransaction(transactionHash, emitter) {
        emitter.emit(constants_1.TRANSACTION_EVENTS_MAP.txSent, { transactionHash });
        this._provider
            .waitForTransaction(transactionHash)
            .then(({ status, blockNumber, transactionHash }) => {
            if (status === 1) {
                emitter.emit(constants_1.TRANSACTION_EVENTS_MAP.txConfirmed, {
                    status,
                    blockNumber,
                    transactionHash,
                });
            }
            else {
                setTimeout(() => {
                    this._provider.getNetwork().then(({ chainId }) => {
                        try {
                            (0, ethRevertReason_1.default)({
                                txHash: transactionHash,
                                networkId: chainId,
                                blockNumber,
                                provider: this._provider,
                            }).then((revertReason) => emitter.emit(constants_1.TRANSACTION_EVENTS_MAP.txFailed, {
                                transactionHash,
                                failureReason: revertReason,
                            }));
                        }
                        catch (e) {
                            emitter.emit(constants_1.TRANSACTION_EVENTS_MAP.txFailed, {
                                transactionHash,
                                failureReason: 'Transaction reverted for an unknown reason',
                            });
                        }
                    });
                }, 5000);
            }
        });
    }
}
exports.TransactionNotifier = TransactionNotifier;
exports.default = TransactionNotifier;
